import { useEffect, useState } from "react";

export const ThemeToggle = () => {
  const [theme, setTheme] = useState(
    () => localStorage.getItem("instinct-theme") || "dark"
  );

  useEffect(() => {
    document.documentElement.setAttribute("data-theme", theme);
    localStorage.setItem("instinct-theme", theme);
  }, [theme]);

  return (
    <button
      data-testid="theme-toggle-button"
      onClick={() => setTheme(theme === "dark" ? "light" : "dark")}
      className="fixed bottom-5 left-5 z-[60] border border-line bg-panel text-ink px-4 py-2 text-[10px] font-bold uppercase tracking-[0.25em] font-['IBM_Plex_Sans'] hover:bg-ink hover:text-page transition-colors"
    >
      Theme: {theme}
    </button>
  );
};
